var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex flex_gap_10" },
      [
        _c(
          "div",
          [
            _c("DateRangePicker", {
              ref: "range",
              staticClass: "w_max_content",
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("multiselect", {
          attrs: {
            options: Object.values(_vm.cards),
            multiple: true,
            label: "id",
            "track-by": "id",
            placeholder: "Выберите карты",
            "select-label": "Выбрать",
            "custom-label": _vm.customLabel,
            "show-labels": false,
            "deselect-label": "Убрать карту",
          },
          model: {
            value: _vm.selectedCards,
            callback: function ($$v) {
              _vm.selectedCards = $$v
            },
            expression: "selectedCards",
          },
        }),
        _vm._v(" "),
        _c("LoadingButton", {
          attrs: {
            title: "Показать",
            className: "btn btn-outline-info",
            onClick: () => _vm.getRecords(),
            loading: _vm.btnLoading,
            color: _vm.$constants.SUCCESS_COLOR,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.records.length
          ? [
              _c(
                "div",
                { staticClass: "flex flex_gap_5 flex-wrap mt-2" },
                _vm._l(_vm.totalExpenses, function (c, id) {
                  return _c(
                    "span",
                    { staticClass: "border p-1" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.cards[id].number.toString().slice(-4)) +
                          ": "
                      ),
                      _vm._l(c, function (s, i) {
                        return _c("strong", [
                          _vm._v(
                            _vm._s(i === 0 ? "" : ", ") +
                              _vm._s(
                                _vm.$AllCurrencies[s.currency_id]?.currency
                              ) +
                              " " +
                              _vm._s(s.total.toLocaleString("ru-RU"))
                          ),
                        ])
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("table", { staticClass: "table table-sm table-hover mt-1" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.records, function (r, i) {
                    return _c("tr", [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            i +
                              1 +
                              ((_vm.paginator?.current_page ?? 1) - 1) *
                                (_vm.paginator?.per_page ?? 1)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(r.card.number.toString().slice(-4))),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(r.card.service_user?.title))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(r.comment))]),
                      _vm._v(" "),
                      _c("td", [_c("strong", [_vm._v(_vm._s(r.sum))])]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.$AllCurrencies[r.currency_id]?.currency)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.printDate(r.pass_date, "DD.MM.YYYY"))
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _vm.paginator
                    ? _c("paginate", {
                        ref: "Pagination",
                        attrs: {
                          "page-count": _vm.paginator.last_page,
                          "page-range": 11,
                          "margin-pages": 2,
                          "click-handler": _vm.getRecords,
                          "prev-text": "&laquo",
                          "next-text": "&raquo",
                          "container-class": "pagination",
                          "prev-class": "page-item",
                          "prev-link-class": "page-link",
                          "page-class": "page-item",
                          "page-link-class": "page-link",
                          "next-class": "page-item",
                          "next-link-class": "page-link",
                          "active-class": "active green_btn",
                        },
                        model: {
                          value: _vm.paginator.current_page,
                          callback: function ($$v) {
                            _vm.$set(_vm.paginator, "current_page", $$v)
                          },
                          expression: "paginator.current_page",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }